import loadable from "@loadable/component";

export const LazyMadeInCanada = loadable(
  () =>
    import(
      /* webpackChunkName: "retailer-made-in-canada-icon" */ "@faire/web/slate/icons/foundation/illustrations/MadeInCanada"
    ),
  { resolveComponent: (m) => m.MadeInCanada }
);
